import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetDashboardData = function () {
    return useApiCall(function (signal, filter) { return api.offer.apiOfferDataGetDashboardDataPost(filter, { signal: signal }); }, [], true, []);
};
